export interface ComicChapter {
  id: number;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  rating: number;
  status: '连载中' | '已完结';
  description: string;
  longDescription: string;
  tags: string[];
  chapters: ComicChapter[];
  views: number;
  favorites: number;
  updateDate: string;
  featured: boolean;
}

export const categories = [
  { slug: 'xingji-manhua', name: '星际漫画', icon: 'ri-rocket-line', description: '探索浩瀚宇宙，星际旅行与外星文明的精彩故事' },
  { slug: 'kehuan-manhua', name: '科幻漫画', icon: 'ri-cpu-line', description: '未来科技、人工智能与人类命运的深刻探讨' },
  { slug: 'yuzhou-manhua', name: '宇宙漫画', icon: 'ri-planet-line', description: '宇宙尺度下的壮丽冒险与文明史诗' },
  { slug: 'xingqiudazhan-manhua', name: '星球大战漫画', icon: 'ri-sword-line', description: '星际战争、银河帝国与反抗军的史诗对决' },
  { slug: 'taikong-manhua', name: '太空漫画', icon: 'ri-space-ship-line', description: '太空探索、宇航员传奇与深空奥秘' },
  { slug: 'xingjimaoxian-manhua', name: '星际冒险漫画', icon: 'ri-compass-3-line', description: '未知星域的探险与惊险刺激的冒险故事' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '银河边境',
    author: '星辰大海',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20opera%20comic%20cover%20with%20a%20lone%20spaceship%20sailing%20through%20a%20colorful%20nebula%2C%20distant%20stars%2C%20cosmic%20dust%2C%20mysterious%20alien%20silhouette%20in%20background%2C%20warm%20orange%20and%20teal%20color%20palette%2C%20cinematic%20lighting%2C%20epic%20scale%2C%20clean%20minimal%20background%20with%20simple%20gradient&width=600&height=800&seq=comic-01&orientation=portrait',
    category: '星际漫画',
    categorySlug: 'xingji-manhua',
    rating: 9.6,
    status: '连载中',
    description: '在银河最遥远的边境线上，一位年轻的星际探索者发现了改变人类命运的秘密。',
    longDescription: '公元2587年，人类已经遍布银河系的各个角落。在银河最遥远的边境线上，年轻的星际探索者林远在执行例行巡逻任务时，意外发现了一座远古外星文明的遗迹。这座遗迹中隐藏的秘密，将彻底改变人类对宇宙的认知。随着调查的深入，林远发现自己卷入了一场跨越数万年的星际阴谋。银河边境的和平岌岌可危，而林远将成为决定银河命运的关键人物。这是一部融合了硬科幻、太空歌剧与人性思考的史诗级星际漫画。',
    tags: ['太空歌剧', '硬科幻', '星际冒险', '外星文明'],
    chapters: [
      { id: 1, title: '第1话：边境的呼唤', updateDate: '2026-08-01' },
      { id: 2, title: '第2话：远古遗迹', updateDate: '2026-07-28' },
      { id: 3, title: '第3话：外星信号', updateDate: '2026-07-25' },
      { id: 4, title: '第4话：星际议会', updateDate: '2026-07-22' },
      { id: 5, title: '第5话：黑暗中的光芒', updateDate: '2026-07-19' },
      { id: 6, title: '第6话：遗迹之谜', updateDate: '2026-07-16' },
      { id: 7, title: '第7话：银河往事', updateDate: '2026-07-13' },
      { id: 8, title: '第8话：觉醒', updateDate: '2026-07-10' },
    ],
    views: 1285000,
    favorites: 89200,
    updateDate: '2026-08-01',
    featured: true,
  },
  {
    id: 2,
    title: '机械纪元',
    author: '未来幻想',
    coverImage: 'https://readdy.ai/api/search-image?query=Cyberpunk%20comic%20cover%20featuring%20a%20female%20android%20with%20glowing%20mechanical%20parts%20visible%2C%20neon%20city%20skyline%20in%20background%2C%20rain%20effects%2C%20warm%20amber%20and%20teal%20tones%2C%20clean%20simple%20dark%20background%2C%20dramatic%20lighting&width=600&height=800&seq=comic-02&orientation=portrait',
    category: '科幻漫画',
    categorySlug: 'kehuan-manhua',
    rating: 9.4,
    status: '连载中',
    description: '在一个被机械主宰的未来世界，人类与人工智能的边界变得模糊不清。',
    longDescription: '2150年，人工智能已经渗透到人类社会的每一个角落。在这个机械与肉体交织的时代，一个拥有自我意识的仿生人少女"零"从实验室中逃脱。她不仅要面对追捕她的军方势力，还要寻找自己存在的意义。在这个被机械主宰的未来世界，人类与人工智能的边界变得模糊不清。零的旅程将带领读者探索意识、自由与爱的本质。这是一部充满哲思与视觉冲击的赛博朋克科幻漫画。',
    tags: ['赛博朋克', '人工智能', '反乌托邦', '未来都市'],
    chapters: [
      { id: 1, title: '第1话：觉醒之日', updateDate: '2026-08-02' },
      { id: 2, title: '第2话：逃离实验室', updateDate: '2026-07-30' },
      { id: 3, title: '第3话：地下世界', updateDate: '2026-07-27' },
      { id: 4, title: '第4话：记忆碎片', updateDate: '2026-07-24' },
      { id: 5, title: '第5话：追猎者', updateDate: '2026-07-21' },
      { id: 6, title: '第6话：同类', updateDate: '2026-07-18' },
    ],
    views: 956000,
    favorites: 67800,
    updateDate: '2026-08-02',
    featured: true,
  },
  {
    id: 3,
    title: '星辰远征军',
    author: '宇宙漫游者',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20space%20fleet%20comic%20cover%20with%20massive%20battle%20cruisers%20in%20deep%20space%2C%20energy%20beams%2C%20explosions%20in%20distance%2C%20heroic%20commander%20silhouette%2C%20warm%20orange%20and%20deep%20teal%20colors%2C%20clean%20cosmic%20background&width=600&height=800&seq=comic-03&orientation=portrait',
    category: '宇宙漫画',
    categorySlug: 'yuzhou-manhua',
    rating: 9.3,
    status: '连载中',
    description: '人类史上最大规模的星际远征，十万艘战舰驶向未知的深空。',
    longDescription: '公元3000年，地球资源枯竭，人类启动了有史以来最宏大的星际远征计划——"星辰远征"。十万艘巨型星际战舰承载着五千万人类精英，驶向银河系深处的宜居星系。然而，远征途中他们遭遇了强大的外星帝国"泽塔文明"。一场关乎人类存亡的星际战争就此展开。星辰远征军的将士们必须用勇气和智慧，在茫茫宇宙中为人类开辟新的家园。',
    tags: ['星际战争', '太空舰队', '文明冲突', '史诗'],
    chapters: [
      { id: 1, title: '第1话：启程', updateDate: '2026-07-31' },
      { id: 2, title: '第2话：深空迷航', updateDate: '2026-07-28' },
      { id: 3, title: '第3话：首次接触', updateDate: '2026-07-25' },
      { id: 4, title: '第4话：战争序曲', updateDate: '2026-07-22' },
      { id: 5, title: '第5话：血战', updateDate: '2026-07-19' },
      { id: 6, title: '第6话：曙光', updateDate: '2026-07-16' },
      { id: 7, title: '第7话：同盟', updateDate: '2026-07-13' },
    ],
    views: 1120000,
    favorites: 76500,
    updateDate: '2026-07-31',
    featured: true,
  },
  {
    id: 4,
    title: '星际风暴',
    author: '银河画师',
    coverImage: 'https://readdy.ai/api/search-image?query=Dynamic%20space%20battle%20comic%20cover%20with%20star%20fighters%20dogfighting%20through%20asteroid%20field%2C%20laser%20bolts%2C%20explosions%2C%20dramatic%20angles%2C%20warm%20golden%20and%20teal%20color%20scheme%2C%20clean%20dark%20space%20background&width=600&height=800&seq=comic-04&orientation=portrait',
    category: '星球大战漫画',
    categorySlug: 'xingqiudazhan-manhua',
    rating: 9.5,
    status: '连载中',
    description: '银河帝国与自由联盟之间的终极对决，星际风暴席卷整个星系。',
    longDescription: '银河帝国统治着数千个星系，铁腕手段压制着一切反抗力量。然而，在帝国边疆的一个小行星上，一群自由战士点燃了反抗的火种。他们驾驶着改装后的星际战机，在帝国舰队的天罗地网中穿梭作战。每一次战斗都关乎自由与奴役的抉择。星际风暴已经形成，没有人能够置身事外。这部漫画以宏大的战争场面和深刻的人物刻画，展现了星际战争的残酷与人性的光辉。',
    tags: ['星际战争', '太空战机', '帝国vs反抗军', '高燃'],
    chapters: [
      { id: 1, title: '第1话：风暴前夜', updateDate: '2026-08-03' },
      { id: 2, title: '第2话：自由之翼', updateDate: '2026-07-31' },
      { id: 3, title: '第3话：帝国反击', updateDate: '2026-07-28' },
      { id: 4, title: '第4话：陨石地带', updateDate: '2026-07-25' },
      { id: 5, title: '第5话：牺牲', updateDate: '2026-07-22' },
      { id: 6, title: '第6话：绝地反击', updateDate: '2026-07-19' },
      { id: 7, title: '第7话：风暴之眼', updateDate: '2026-07-16' },
      { id: 8, title: '第8话：新黎明', updateDate: '2026-07-13' },
    ],
    views: 1450000,
    favorites: 98500,
    updateDate: '2026-08-03',
    featured: true,
  },
  {
    id: 5,
    title: '深空漂流',
    author: '星际旅人',
    coverImage: 'https://readdy.ai/api/search-image?query=Lonely%20astronaut%20floating%20in%20deep%20space%20comic%20cover%2C%20distant%20galaxy%20spiral%2C%20cosmic%20rays%2C%20mysterious%20planet%20silhouette%2C%20warm%20golden%20light%20from%20distant%20star%2C%20teal%20nebula%2C%20clean%20minimal%20space%20background&width=600&height=800&seq=comic-05&orientation=portrait',
    category: '太空漫画',
    categorySlug: 'taikong-manhua',
    rating: 9.2,
    status: '已完结',
    description: '一艘意外偏离航线的太空船，一段穿越未知宇宙的孤独旅程。',
    longDescription: '近未来，一艘名为"探索者号"的科研飞船在前往木星卫星的途中遭遇了神秘的空间异常，被抛向了完全未知的星系。船上七名宇航员必须依靠有限资源和彼此信任，在陌生的宇宙中寻找回家的路。他们经历了奇异的外星现象、致命的宇宙辐射和船员之间的信任危机。这不仅是一次太空漂流，更是一次对人类孤独与希望的深刻探索。',
    tags: ['太空探索', '生存', '硬科幻', '人性'],
    chapters: [
      { id: 1, title: '第1话：启航', updateDate: '2026-06-15' },
      { id: 2, title: '第2话：异常信号', updateDate: '2026-06-12' },
      { id: 3, title: '第3话：迷失', updateDate: '2026-06-09' },
      { id: 4, title: '第4话：陌生星系', updateDate: '2026-06-06' },
      { id: 5, title: '第5话：资源危机', updateDate: '2026-06-03' },
      { id: 6, title: '第6话：船员分裂', updateDate: '2026-05-31' },
      { id: 7, title: '第7话：外星遗迹', updateDate: '2026-05-28' },
      { id: 8, title: '第8话：希望的坐标', updateDate: '2026-05-25' },
      { id: 9, title: '第9话：归途（大结局）', updateDate: '2026-05-22' },
    ],
    views: 870000,
    favorites: 54300,
    updateDate: '2026-06-15',
    featured: false,
  },
  {
    id: 6,
    title: '异星猎手',
    author: '星际旅人',
    coverImage: 'https://readdy.ai/api/search-image?query=Bounty%20hunter%20in%20alien%20planet%20market%20comic%20cover%2C%20exotic%20alien%20creatures%2C%20hovering%20vehicles%2C%20colorful%20neon%20signs%2C%20warm%20amber%20and%20teal%20lighting%2C%20clean%20simple%20composition&width=600&height=800&seq=comic-06&orientation=portrait',
    category: '星际冒险漫画',
    categorySlug: 'xingjimaoxian-manhua',
    rating: 9.1,
    status: '连载中',
    description: '银河系最著名的赏金猎人，穿梭于各个星球追捕最危险的逃犯。',
    longDescription: '在银河系的边缘地带，法律往往鞭长莫及。赏金猎人凯恩是这片法外之地最令人闻风丧胆的名字。他接受各方势力的委托，追捕那些逃亡到星际角落的危险罪犯。从繁华的星际都市到蛮荒的外星丛林，从高重力矿星到零重力空间站，凯恩的足迹遍布整个银河。然而，一桩看似普通的赏金任务，却将他卷入了一场足以颠覆银河秩序的惊天阴谋。',
    tags: ['赏金猎人', '星际冒险', '犯罪追踪', '太空西部'],
    chapters: [
      { id: 1, title: '第1话：赏金令', updateDate: '2026-07-29' },
      { id: 2, title: '第2话：星际都市', updateDate: '2026-07-26' },
      { id: 3, title: '第3话：线索追踪', updateDate: '2026-07-23' },
      { id: 4, title: '第4话：沙漠行星', updateDate: '2026-07-20' },
      { id: 5, title: '第5话：幕后黑手', updateDate: '2026-07-17' },
    ],
    views: 720000,
    favorites: 45600,
    updateDate: '2026-07-29',
    featured: false,
  },
  {
    id: 7,
    title: '量子之门',
    author: '星辰大海',
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20portal%20opening%20in%20laboratory%20comic%20cover%2C%20scientists%20in%20background%2C%20glowing%20energy%20rings%2C%20parallel%20universe%20glimpse%2C%20warm%20orange%20and%20teal%20scientific%20aesthetic%2C%20clean%20modern%20style&width=600&height=800&seq=comic-07&orientation=portrait',
    category: '科幻漫画',
    categorySlug: 'kehuan-manhua',
    rating: 9.0,
    status: '连载中',
    description: '科学家意外打开了通往平行宇宙的量子之门，发现了一个截然不同的世界。',
    longDescription: '位于月球背面的"天穹实验室"中，一组顶尖量子物理学家正在进行一项前所未有的实验——打开通往平行宇宙的通道。当量子之门真正被激活的那一刻，所有人都震惊了。门的那一边，是一个与地球截然不同却又惊人相似的平行世界。两个世界的命运从此紧密相连。然而，量子之门的开启也引起了两个世界之间微妙的平衡危机。科学家们必须在探索未知和维护安全之间做出艰难抉择。',
    tags: ['平行宇宙', '量子物理', '科学探索', '悬疑'],
    chapters: [
      { id: 1, title: '第1话：天穹实验室', updateDate: '2026-07-27' },
      { id: 2, title: '第2话：共振', updateDate: '2026-07-24' },
      { id: 3, title: '第3话：门的那一边', updateDate: '2026-07-21' },
      { id: 4, title: '第4话：另一个地球', updateDate: '2026-07-18' },
      { id: 5, title: '第5话：平衡', updateDate: '2026-07-15' },
      { id: 6, title: '第6话：危机', updateDate: '2026-07-12' },
    ],
    views: 680000,
    favorites: 43200,
    updateDate: '2026-07-27',
    featured: false,
  },
  {
    id: 8,
    title: '星际殖民录',
    author: '宇宙漫游者',
    coverImage: 'https://readdy.ai/api/search-image?query=Terraforming%20colony%20on%20alien%20planet%20comic%20cover%2C%20domed%20cities%2C%20red%20alien%20landscape%2C%20spaceships%20landing%2C%20settlers%20silhouettes%2C%20warm%20amber%20sunset%20sky%20with%20two%20moons%2C%20clean%20composition&width=600&height=800&seq=comic-08&orientation=portrait',
    category: '星际漫画',
    categorySlug: 'xingji-manhua',
    rating: 9.0,
    status: '连载中',
    description: '人类在遥远星系建立殖民地，面对严酷环境与未知威胁的生存故事。',
    longDescription: '2180年，第一批人类殖民者抵达了距离地球42光年的特拉普斯特-1星系。在这颗被称为"新希望"的行星上，殖民者们必须面对极端的气候、陌生的生态系统和资源匮乏的困境。更令人担忧的是，这颗行星上似乎存在着某种古老的原生智慧。人类在星际殖民的进程中，究竟是开拓者还是入侵者？这部漫画以宏大的视角描绘了人类星际殖民的壮丽与残酷。',
    tags: ['星际殖民', '外星环境', '生存', '文明反思'],
    chapters: [
      { id: 1, title: '第1话：着陆', updateDate: '2026-07-25' },
      { id: 2, title: '第2话：新家园', updateDate: '2026-07-22' },
      { id: 3, title: '第3话：第一个冬天', updateDate: '2026-07-19' },
      { id: 4, title: '第4话：发现', updateDate: '2026-07-16' },
      { id: 5, title: '第5话：原住民', updateDate: '2026-07-13' },
      { id: 6, title: '第6话：共存还是征服', updateDate: '2026-07-10' },
    ],
    views: 590000,
    favorites: 38700,
    updateDate: '2026-07-25',
    featured: false,
  },
  {
    id: 9,
    title: '银河舰队',
    author: '银河画师',
    coverImage: 'https://readdy.ai/api/search-image?query=Military%20space%20fleet%20formation%20comic%20cover%2C%20rows%20of%20battleships%2C%20admiral%20on%20bridge%2C%20tactical%20hologram%20display%2C%20warm%20golden%20command%20center%20lighting%2C%20teal%20space%20outside%20viewport%2C%20clean%20epic%20style&width=600&height=800&seq=comic-09&orientation=portrait',
    category: '星球大战漫画',
    categorySlug: 'xingqiudazhan-manhua',
    rating: 9.3,
    status: '已完结',
    description: '银河联合舰队对抗外星入侵者的史诗战争，人类存亡在此一战。',
    longDescription: '当来自仙女座星系的外星舰队突然出现在银河系边缘时，人类第一次意识到自己并非宇宙中唯一的智慧文明。这些被称为"湮灭者"的外星种族拥有远超人类的技术。银河联合舰队在仓促中组建，集结了人类及各同盟文明的全部军事力量。从最初的溃败到最后的绝地反击，这部漫画记录了人类历史上最伟大的太空战争。每一场战役都充满了策略、牺牲与荣耀。',
    tags: ['太空战争', '舰队战', '策略', '史诗'],
    chapters: [
      { id: 1, title: '第1话：入侵', updateDate: '2026-05-10' },
      { id: 2, title: '第2话：联合舰队', updateDate: '2026-05-07' },
      { id: 3, title: '第3话：第一次接触战', updateDate: '2026-05-04' },
      { id: 4, title: '第4话：撤退', updateDate: '2026-05-01' },
      { id: 5, title: '第5话：困兽之斗', updateDate: '2026-04-28' },
      { id: 6, title: '第6话：反击计划', updateDate: '2026-04-25' },
      { id: 7, title: '第7话：终局之战', updateDate: '2026-04-22' },
      { id: 8, title: '第8话：和平（大结局）', updateDate: '2026-04-19' },
    ],
    views: 1350000,
    favorites: 91200,
    updateDate: '2026-05-10',
    featured: false,
  },
  {
    id: 10,
    title: '太空海盗传奇',
    author: '星际旅人',
    coverImage: 'https://readdy.ai/api/search-image?query=Space%20pirate%20ship%20in%20asteroid%20belt%20comic%20cover%2C%20rugged%20captain%2C%20treasure%20chest%20floating%2C%20laser%20pistols%2C%20ramshackle%20ship%20design%2C%20warm%20orange%20and%20teal%20adventure%20vibe%2C%20clean%20composition&width=600&height=800&seq=comic-10&orientation=portrait',
    category: '星际冒险漫画',
    categorySlug: 'xingjimaoxian-manhua',
    rating: 8.9,
    status: '连载中',
    description: '一群逍遥法外的太空海盗，在银河系中寻找传说中的星际宝藏。',
    longDescription: '在银河法律管辖不到的三不管地带，太空海盗是真正的统治者。"赤色彗星号"的船长杰克·星刃是这一带最臭名昭著的海盗头子。他带领着一群各怀绝技的船员，驾驶着改装过的星际海盗船，在星际航线上劫富济贫，同时也在追寻着一个流传了数百年的传说——"银河之心"，据说那是远古超文明留下的终极宝藏。轻松幽默又不乏热血激战，是这部漫画的独特魅力。',
    tags: ['太空海盗', '冒险', '喜剧', '寻宝'],
    chapters: [
      { id: 1, title: '第1话：赤色彗星号', updateDate: '2026-07-23' },
      { id: 2, title: '第2话：第一桶金', updateDate: '2026-07-20' },
      { id: 3, title: '第3话：海军追捕', updateDate: '2026-07-17' },
      { id: 4, title: '第4话：星图碎片', updateDate: '2026-07-14' },
      { id: 5, title: '第5话：叛徒', updateDate: '2026-07-11' },
    ],
    views: 620000,
    favorites: 41200,
    updateDate: '2026-07-23',
    featured: false,
  },
  {
    id: 11,
    title: '宇宙起源',
    author: '未来幻想',
    coverImage: 'https://readdy.ai/api/search-image?query=Cosmic%20creation%20myth%20comic%20cover%2C%20big%20bang%20visualization%2C%20forming%20galaxies%2C%20primordial%20light%2C%20celestial%20beings%2C%20warm%20golden%20and%20teal%20cosmic%20colors%2C%20clean%20elegant%20abstract%20style&width=600&height=800&seq=comic-11&orientation=portrait',
    category: '宇宙漫画',
    categorySlug: 'yuzhou-manhua',
    rating: 9.7,
    status: '已完结',
    description: '从宇宙大爆炸到文明诞生，一部跨越百亿年的宇宙史诗。',
    longDescription: '这部漫画以独特的视角讲述了宇宙从诞生到现在的138亿年历史。从最初的大爆炸奇点，到第一批星系的形成，从恒星的生命周期到行星系统的演化，从地球上第一个生命的萌发到智慧文明的崛起。每一页都是一幅宏大的宇宙画卷，每一个章节都是一段震撼的时空旅程。它不仅是一部科普漫画，更是一部关于宇宙、生命与意识的哲学诗篇。适合所有对宇宙充满好奇的读者。',
    tags: ['宇宙学', '科普', '哲学', '史诗'],
    chapters: [
      { id: 1, title: '第1章：奇点与爆炸', updateDate: '2026-04-01' },
      { id: 2, title: '第2章：星系的诞生', updateDate: '2026-03-29' },
      { id: 3, title: '第3章：恒星时代', updateDate: '2026-03-26' },
      { id: 4, title: '第4章：行星的演化', updateDate: '2026-03-23' },
      { id: 5, title: '第5章：生命的曙光', updateDate: '2026-03-20' },
      { id: 6, title: '第6章：智慧的火种', updateDate: '2026-03-17' },
      { id: 7, title: '第7章：宇宙的未来（终章）', updateDate: '2026-03-14' },
    ],
    views: 980000,
    favorites: 112000,
    updateDate: '2026-04-01',
    featured: false,
  },
  {
    id: 12,
    title: '群星之间',
    author: '星辰大海',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20space%20journey%20comic%20cover%2C%20two%20astronauts%20gazing%20at%20stars%20through%20spaceship%20window%2C%20beautiful%20nebula%2C%20warm%20intimate%20lighting%2C%20orange%20and%20teal%20color%20palette%2C%20clean%20emotional%20style&width=600&height=800&seq=comic-12&orientation=portrait',
    category: '太空漫画',
    categorySlug: 'taikong-manhua',
    rating: 9.4,
    status: '连载中',
    description: '两个来自不同星球的灵魂，在浩瀚宇宙中相遇的浪漫科幻故事。',
    longDescription: '地球宇航员苏琳在执行国际空间站任务时，意外接收到了一串神秘的外星信号。信号来自一个遥远星系中的类人文明。通过跨星际通讯，她与那个文明的一位年轻科学家建立了联系。尽管相隔数十光年，两颗孤独的心灵在浩瀚的宇宙中找到了彼此。这部漫画以细腻的情感描绘和宏大的宇宙背景，讲述了一段跨越星际的爱情故事，同时探讨了沟通、理解与连接的本质。',
    tags: ['浪漫科幻', '星际通讯', '文艺', '情感'],
    chapters: [
      { id: 1, title: '第1话：信号', updateDate: '2026-07-21' },
      { id: 2, title: '第2话：破译', updateDate: '2026-07-18' },
      { id: 3, title: '第3话：第一次对话', updateDate: '2026-07-15' },
      { id: 4, title: '第4话：彼此的世界', updateDate: '2026-07-12' },
      { id: 5, title: '第5话：星海相隔', updateDate: '2026-07-09' },
      { id: 6, title: '第6话：跨越光年', updateDate: '2026-07-06' },
    ],
    views: 810000,
    favorites: 67800,
    updateDate: '2026-07-21',
    featured: false,
  },
];

export const featuredComics = comics.filter((c) => c.featured);
export const latestComics = [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime());
export const popularComics = [...comics].sort((a, b) => b.views - a.views);

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.categorySlug === slug);
}

export function getCategoryBySlug(slug: string) {
  return categories.find((c) => c.slug === slug);
}